import { StatModule } from "@/core/modules/stat/objects/StatModule";

import InvoiceByYearView from "./views/InvoiceByYearView.vue";

export const invoiceByYear: StatModule = new StatModule("invoice", "InvoiceByYear", "invoice", InvoiceByYearView);
